/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Verb_Task_CanceledInputs */

const en_case_history_verb_task_canceled = /** @type {(inputs: Case_History_Verb_Task_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`canceled`)
};

const pt_br2_case_history_verb_task_canceled = /** @type {(inputs: Case_History_Verb_Task_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cancelada`)
};

/**
* | output |
* | --- |
* | "canceled" |
*
* @param {Case_History_Verb_Task_CanceledInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_verb_task_canceled = /** @type {((inputs?: Case_History_Verb_Task_CanceledInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Verb_Task_CanceledInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_verb_task_canceled(inputs)
	return pt_br2_case_history_verb_task_canceled(inputs)
});